import GuestLayout from '../../components/layout/GuestLayout.jsx';
import BaseButton from '../../components/form/BaseButton.jsx';
import { useResendVerifyEmailMutation } from '../../api/auth.js';
import BaseLink from '../../components/misc/BaseLink.jsx';

const CheckEmail = () => {
    const [resendVerifyEmail, { isLoading }] = useResendVerifyEmailMutation();

    const resendVerificationEmail = async () => {
        await resendVerifyEmail(null);
    };

    return (
        <GuestLayout title='Check Email'>
            <div className='text-theme1-white'>
                We've emailed you a verification link for your email address, you need to verify your email before
                continue.
            </div>
            <div className='flex justify-center mt-10 mb-10'>
                <BaseButton
                    id='btn-submit'
                    className='btn-primary'
                    onClick={resendVerificationEmail}
                    isLoading={isLoading}
                    textValue='Resend verification email'
                />
            </div>
            <div className='flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/logout'>
                    Logout
                </BaseLink>
            </div>
        </GuestLayout>
    );
};

export default CheckEmail;
